export const EVENTALERTS_SUCCESS = "EVENTALERTS_SUCCESS";
export const EVENTALERTS_READ = "EVENTALERTS_READ";
export const AUTHORIZATIONS_RELOAD = "AUTHORIZATIONS_RELOAD";
export const AUTHORIZATIONS_SUCCESS = "AUTHORIZATIONS_SUCCESS";
export const AUTHORIZATIONS_READ = "AUTHORIZATIONS_READ";
export const NOTIFICATIONS_RELOAD = "NOTIFICATIONS_RELOAD";
export const NOTIFICATIONS_SUCCESS = "NOTIFICATIONS_SUCCESS";
export const NOTIFICATIONS_LOADING = "NOTIFICATIONS_LOADING";
export const ORDER_SUCCESS = "ORDER_SUCCESS";
export const ACCOUNT_SET = "ACCOUNT_SET";
export const PERSON_INFO_SET = "PERSON_INFO_SET";
export const TEXTS_SET = "TEXTS_SET";
export const TEXTS_LOADING_SET = "TEXTS_LOADING_SET";

export function eventAlertsSuccess(eventAlerts) {
  return {
    type: EVENTALERTS_SUCCESS,
    payload: {
      eventAlerts,
    },
  };
}

export function eventAlertsRead(id) {
  return {
    type: EVENTALERTS_READ,
    payload: {
      id,
    },
  };
}

export function authorizationsReload() {
  return {
    type: AUTHORIZATIONS_RELOAD,
    payload: {},
  };
}

export function authorizationsSuccess(authorizations) {
  return {
    type: AUTHORIZATIONS_SUCCESS,
    payload: {
      authorizations,
    },
  };
}

export function notificationsReload() {
  return {
    type: NOTIFICATIONS_RELOAD,
    payload: {},
  };
}

export function notificationsSuccess(notifications) {
  return {
    type: NOTIFICATIONS_SUCCESS,
    payload: {
      notifications,
    },
  };
}

export function setNotificationsLoading(notificationsLoading) {
  return {
    type: NOTIFICATIONS_LOADING,
    payload: {
      notificationsLoading,
    },
  };
}

export function currentAccountSet(account) {
  return {
    type: ACCOUNT_SET,
    payload: {
      account,
    },
  };
}

export function personInfoSet(person) {
  return {
    type: PERSON_INFO_SET,
    payload: {
      person,
    },
  };
}

export function textsSet(texts) {
  return {
    type: TEXTS_SET,
    payload: {
      texts,
    },
  };
}

export function textsLoadingSet() {
  return {
    type: TEXTS_LOADING_SET,
    payload: {
      textsLoading: true,
    },
  };
}
